import Navigation from "./navigation.marko";
import LocaleLinks from "./locale-links.marko";

export interface Input {
  isOpen: boolean;
}

<style/styles: any>
  .menu {
    transform: translateY(-200%);
    position: absolute;
    transition: transform cubic-bezier(0.4, 0, 0.2, 1) 0.15s;
  }

  .menu[data-state="open"] {
    transform: translateY(0);
  }
</style>

<div
  data-state=input.isOpen ? "open" : "closed"
  class=["bg-light si-100 pb1", !input.isOpen && "invisible", styles.menu]
>
  <nav>
    <Navigation class="flex flex-col align-items-center gap0"/>
  </nav>
  <div aria-label="Languages">
    <LocaleLinks class="flex justify-content-center pbs5 gap0"/>
  </div>
</div>
